import { HeadType } from 'components/layout/table/head'

export default {
  head: [
    {
      label: null,
      key: 'blank',
      col: 10,
      type: HeadType.Blank,
    },
    {
      label: 'Zwischensumme',
      key: 'nettoPrice',
      unit: 'EUR',
      col: 2,
      type: HeadType.Highlight,
    },
  ],
  isAggregation: true,
  big: true,
}
